import template from 'lodash/template';

const SEPARATOR = '-';
const UNKNOWN_ERROR = 'unknown_error';

export default {
    data() {
        return {
            templatePrefix: undefined,
        };
    },

    methods: {
        /**
         * Find error message in DOM templates and returns compiled result
         * @param {string} messageId
         * @param {object} data
         * @param {string} errorMessageCallbackTemplate
         */
        getErrorMessage(messageId, data, errorMessageCallbackTemplate) {
            if (!this.templatePrefix) {
                throw new Error(
                    'You must define `templatePrefix` inside props or data of your component',
                );
            }

            const ids = [[this.templatePrefix, messageId].join(SEPARATOR)];
            let message;

            if (this.formName) {
                ids.push([this.templatePrefix, this.formName, messageId].join(SEPARATOR));
            }

            // eslint-disable-next-line
            for (let id of ids) {
                const foundMessage = document.getElementById(id);

                if (foundMessage) {
                    message = foundMessage;
                    break;
                }
            }

            if (message) {
                return template(message.innerHTML)(data || {});
            }

            console.log(`Template message not found by id ${ids}`);

            if (errorMessageCallbackTemplate) {
                message = document.getElementById(errorMessageCallbackTemplate);

                if (message) {
                    return template(message.innerHTML)(data || {});
                }
                console.log(
                    `Callback template message not found by id ${errorMessageCallbackTemplate}`,
                );
            }

            if (messageId === UNKNOWN_ERROR) {
                throw new Error('Missing default error message template');
            }

            return this.getErrorMessage(UNKNOWN_ERROR);
        },
    },
};
